import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Text, View } from 'react-native';
import './TitleArrow.css';
var TitleArrow = function TitleArrow(_ref) {
  var _order$find;
  var order = _ref.order,
    styles = _ref.styles,
    canSort = _ref.canSort,
    key = _ref.columnKey;
  var direction = order && ((_order$find = order.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.key) === key;
  })) === null || _order$find === void 0 ? void 0 : _order$find.direction);
  var arrow = '-';
  var arrowColor = 'transparent';
  var className = 'title-arrow';
  if ('asc' === direction) {
    arrow = '↑';
    arrowColor = 'green';
    className = 'title-arrow sort-asc';
  } else if ('desc' === direction) {
    arrow = '↓';
    arrowColor = 'red';
    className = 'title-arrow sort-desc';
  } else if (canSort) {
    arrow = '↕';
    arrowColor = 'gray';
    className = 'title-arrow sort';
  }
  var style = _objectSpread(_objectSpread({
    fontWeight: 'bold'
  }, styles === null || styles === void 0 ? void 0 : styles.label), {}, {
    paddingLeft: 10,
    fontSize: '0.8em',
    color: arrowColor
  }, styles === null || styles === void 0 ? void 0 : styles.arrowStyle);
  return /*#__PURE__*/React.createElement("i", {
    className: className,
    style: style
  });
};
export default TitleArrow;